// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"c6d15e8d","578":"8f38c0b9","637":"a661b608","829":"59116f91","980":"eabadae0"}[chunkId] + ".chunk.js";
};